// extracted by mini-css-extract-plugin
export default {"modalContainer":"x1","fadeIn":"y1","img":"z1","fadeInImg":"A1","greeting":"B1","fadeInGreeting":"C1","imgWrapper":"E1","name":"F1","fadeInName":"G1"};
    if(module.hot) {
      // 1711394580266
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  